import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ReactSpinner from "react-spinjs-fix";

import Show from "../widgets/Show";
import bindActions from "../../helpers/bindActions";
import { Routes } from "../../constants/Routes";
import { AppLayout } from "../app-layout/AppLayout";
import { SelectPicker } from "../select-picker/SelectPicker";
import { createUrl, parseQuery } from "../../utils/UrlUtils";
import { getCompanyFormatDate, getCompanyFormatTime } from "../../helpers/DateUtils";
import { ReactComponent as SortArrowAsc } from "../../assets/images/patient/sortArrowAsc.svg";
import { ReactComponent as SortArrowDesc } from "../../assets/images/patient/sortArrowDesc.svg";
import NoteImage from "../../assets/images/notes@2x.png";
import LogImage from "../../assets/images/log-file-format.png";
import AppointmentImage from "../../assets/images/profile/appointments.png";
import * as patientRegisterActions from "../../actions/patientRegisterActions";
import PatientAppointmentsListReasonModal from "./PatientAppointmentsListReasonModal";

const enhancer = connect(
  ({ session: { member }, patientRegister }) => ({ patientRegister, member }),
  bindActions({ patientRegisterActions }),
);
class PatientAppointmentsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStatuses: [],
    };
  }

  componentDidMount() {
    const { onlyCompleted } = this.state;
    const { patientRegisterActions, location } = this.props;
    const query = parseQuery(location.search);

    this.getList(onlyCompleted);

    patientRegisterActions.loadTotalCancelledMissedCompletedReleasedAppTList(
      query.patientKey || this.props.patientKey,
    );
  }

  getList = (statuses) => {
    const { patientRegisterActions, location } = this.props;

    const query = parseQuery(location.search);

    patientRegisterActions.getPatientAppointmentsList(
      query.patientKey || this.props.patientKey,
      statuses ? statuses : undefined,
    );
  };

  loadList = (e) => {
    const scrollBottom = e.target.scrollTop + e.target.offsetHeight + 1 >= e.target.scrollHeight;
    const selectedStatusesList = (this.state.selectedStatuses || [])
      .map((status) => status.value)
      .join(",");

    if (scrollBottom) {
      const { patientRegisterActions, location } = this.props;

      const query = parseQuery(location.search);

      patientRegisterActions.loadPatientAppointmentsList(
        query.patientKey || this.props.patientKey,
        selectedStatusesList ? selectedStatusesList : undefined,
      );
    }
  };
  selectHandler = () => {
    const { location } = this.props;
    const query = parseQuery(location.search);

    this.props.patientRegisterActions.selectSortFieldHandler(
      query.patientKey || this.props.patientKey,
    );
  };

  handleStatusChange = (selectedOptions) => {
    this.setState({ selectedStatuses: selectedOptions || [] });
  };

  handleMenuClose = () => {
    const selectedStatusesList = (this.state.selectedStatuses || [])
      .map((status) => status.value)
      .join(",");

    this.getList(selectedStatusesList);
  };

  render() {
    const {
      appointmentsList,
      fetchingAppointmentsList,
      patientInfo,
      appointmentsReasonModalVisible,
      appointmentsLogModalIndex,
      appointmentsReasonModalId,
      appointmentsReasonModalData,
      appointmentsReasonModalMode,
      appointmentUpcomingTotalCount,
      appointmentMissedTotalCount,
      appointmentCompleteTotalCount,
      appointmentAllTotalCount,
      appointmentWithoutLateCancelledTotalCount,
      statusOptions,
      startDateDescendant,
    } = this.props.patientRegister;

    const list = (appointmentsList || []).map((element, index) => {
      const communicationStatus = element.noAnswer
        ? "No answer"
        : element.notInterested
        ? "Not interested"
        : element.willCall
        ? "Will call back"
        : "";

      return (
        <div className="appointments-list-row" key={element.id}>
          <div>{_.upperCase((element.category && element.category.name) || "")}</div>
          <div>{_.get(element, "clinic.name", "")}</div>
          <div>{(element.dentist && element.dentist.name) || ""}</div>
          <div>{element.date ? getCompanyFormatDate(element.date) : ""}</div>
          <div>{element.date ? getCompanyFormatTime(element.date) : ""}</div>
          <div>{(element.meetingType && element.meetingType.name) || ""}</div>
          <div className="text-center">
            {(element.priorAuthorizationID && element.priorAuthorizationID) || ""}
          </div>
          <div>{communicationStatus}</div>
          <div>{_.upperCase(element.status.name || "")}</div>

          <div className="log-buttons">
            <button
              type="button"
              onClick={() => {
                this.props.patientRegisterActions.appointmentsReasonModalShow(
                  element.id,
                  "log",
                  index,
                );
              }}
              className="btn btn-info button-doctors"
              style={{ padding: 0 }}
            >
              <img src={LogImage} style={{ zoom: "50%" }} alt="" width={34} height={34} />
            </button>
            <button
              type="button"
              className="btn btn-info button-notes"
              style={{ padding: 0 }}
              onClick={() => {
                this.props.patientRegisterActions.appointmentsReasonModalShow(
                  element.id,
                  "reason",
                  index,
                );
              }}
            >
              <img src={NoteImage} style={{ zoom: "50%" }} alt="" width={34} height={34} />
            </button>
            <button
              type="button"
              className="btn btn-info button-appointment"
              style={{ padding: 0 }}
              onClick={() => {
                this.props.history.push(
                  createUrl(Routes.DashboardAppointment, { params: { id: element.id } }),
                );
              }}
            >
              <img src={AppointmentImage} style={{ zoom: "50%" }} alt="" width={34} height={34} />
            </button>
          </div>
        </div>
      );
    });

    const query = parseQuery(this.props.location.search);

    let patientData = patientInfo.firstName || "";
    const lastName = patientInfo.lastName || "";
    const chartNumber = patientInfo.chartNumber || "";

    patientData += lastName !== "" ? ` ${lastName}` : "";
    patientData += patientData !== "" && chartNumber !== "" ? ", " : "";
    patientData += chartNumber !== "" ? `#${chartNumber}` : "";

    return (
      <AppLayout
        onBackClick={() => {
          if (this.props.onBackClick) {
            return this.props.onBackClick();
          }
          if (query.appointmentForm === "true") {
            this.props.history.push(
              createUrl(Routes.DashboardAppointment, {
                params: { id: query.appointmentId },
                query: {
                  ...query,
                  patientKey: query.patientKey || this.props.patientKey,
                },
              }),
            );
          } else {
            this.props.history.goBack();
          }
        }}
        contentClassName="patient-appointments-list"
        rightComponentClassName="btn-user-name"
        withLogo={true}
        rightComponent={patientData}
      >
        <div className="complete-switcher-container d-flex">
          <div
            className="row"
            style={{
              flex: 6,
              display: "flex",
              marginTop: "1rem",
              fontWeight: "bold",
              justifyContent: "flex-end",
            }}
          >
            <div className="col-sm-7 d-flex align-items-center">
              <div style={{ width: "22%" }}>
                <SelectPicker
                  isMulti={true}
                  clearable={true}
                  isSearchable={false}
                  value={this.state.selectedStatuses}
                  options={statusOptions}
                  onChange={this.handleStatusChange}
                  onMenuClose={this.handleMenuClose}
                />
              </div>
            </div>
            <div className="col-sm-2">
              <p className="mb-0">
                Total Cancelled:{" "}
                <b className="text-black">{appointmentWithoutLateCancelledTotalCount}</b>
              </p>
              <p className="mb-0">
                Total Missed: <b className="text-black">{appointmentMissedTotalCount}</b>
              </p>
              <p className="mb-0">
                Total Complete: <b className="text-black">{appointmentCompleteTotalCount}</b>
              </p>
            </div>
            <div className="col-sm-3">
              <p className="mb-0">
                Upcoming: <b className="text-black">{appointmentUpcomingTotalCount}</b>
              </p>
              <p className="mb-0">
                Total Release: <b className="text-black">{appointmentAllTotalCount}</b>
              </p>
            </div>
          </div>
        </div>
        <div className="appointments-list-table">
          <div className="appointments-list-header">
            <div>Appointment type</div>
            <div>Clinic</div>
            <div>{localStorage.getItem("doctorLabel")}</div>
            <div role="button" onClick={this.selectHandler} className="d-flex col-gap-2">
              <span>Date</span>
              {startDateDescendant ? (
                <SortArrowDesc
                  style={{ height: 23, transform: "translateY(-3px)", cursor: "pointer" }}
                />
              ) : (
                <SortArrowAsc
                  style={{ height: 23, transform: "translateY(-3px)", cursor: "pointer" }}
                />
              )}
            </div>
            <div>Time</div>
            <div>Meeting type</div>
            <div>Prior-Approval Auth ID</div>
            <div>Communication status</div>
            <div>Status</div>
            <div>&nbsp;</div>
          </div>
          <div className="appointments-list-body" onScroll={this.loadList}>
            {list}
            <Show if={fetchingAppointmentsList}>
              <ReactSpinner />
            </Show>
          </div>
        </div>
        <Show if={appointmentsReasonModalVisible}>
          <PatientAppointmentsListReasonModal
            show={appointmentsReasonModalVisible}
            appointmentsReasonModalData={appointmentsReasonModalData}
            mode={appointmentsReasonModalMode}
            appointmentsList={appointmentsList}
            index={appointmentsLogModalIndex}
            id={appointmentsReasonModalId}
          />
        </Show>
      </AppLayout>
    );
  }
}

export default withRouter(enhancer(PatientAppointmentsList));
